import { Button, Container, Grid } from '@material-ui/core'
import styled from 'styled-components'

const MoreFromHexContainer = styled.section`
  background: var(--color-primary);
  color: white;

  h3 {
    margin-bottom: 30px;
  }

  h4 {
    margin-bottom: 30px;
    font-size: 1.5rem;
    font-weight: 600;
  }

  .online-training {
    margin-top: 40px;
    padding: 30px;

    .content {
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding-right: 30px;
    }

    p {
      font-size: 0.75rem;
      line-height: 1.25rem;

      &:last-of-type {
        margin-bottom: 0;

      }
    }`

const MoreFromHexagon = () => {
  return (

    <MoreFromHexContainer className="more-from-hexagon">
      <Container style={{ minHeight: 'unset' }}>
        {/* <h3>More from Hexagon</h3>

        <Grid container spacing={6}>
          <Grid item sm={6} xs={12}>
            <img
              src="images/homepage/more-from-hexagon/premium-access.jpg"
              alt="Hexagon premium access plans"
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <div className="accent"></div>
            <h4>Hexagon premium access pass</h4>
            <p className="fs14">
              Our Goal, with this program, is to increase productivity for
              customers who want to extract maximum out of their Hexagon
              systems.
            </p>

            <p className="fs14">
              This pass will grant you access to our world class precision
              centers, where you’ll get to work directly with our Senior
              Applications Engineer(s) on increasing the throughput on your
              Hexagon systems.
            </p>

            <p className="fs14 m-b-30">
              Our centers, will be open to pass holders Saturday’s from 8-12
              (noon). This is your chance to engage with our best and brightest
              on topics that will make your CMM / Quality department more
              efficient.
            </p>

            <Button className="btn-white">Learn more</Button>
          </Grid>
        </Grid> */}

        <Grid
          container
          spacing={0}
          className="black-bg m-t-40 p-r-30 p-l-30 p-t-30 p-b-30"
        >
          <Grid item sm={8} className="content">
            <h4 className="p-t-16">Hexagon online training</h4>
            <p className="fs14 m-b-30">
              Efficient and effective use of metrology equipment relies on
              skilled and knowledgeable users. Training and support delivered by
              experienced professionals is crucial to ensure your operators have
              the expertise to maximise inspection productivity. Contact one of
              our experts to help with any pressing issues you might have.
            </p>
            <p className="fs14">
              <a
                href="https://www.hexagonmi.com/en-us/service-and-support/training"
                target="_blank"
                rel="noreferrer"
              >
                <Button className="btn-white">Learn more</Button>
              </a>
            </p>
          </Grid>
          <Grid item sm={4}>
            <img
              src="images/homepage/more-from-hexagon/online-training.jpg"
              alt="Online Training"
            />
          </Grid>
        </Grid>
      </Container>
    </MoreFromHexContainer>
  )
}

export default MoreFromHexagon
